import React, { Component } from 'react';

import {
    Popup,
} from '../../index';

import '../../../asset/css/style.css';

import PropTypes from 'prop-types';

import {FaWindowClose} from 'react-icons/fa';

import ReleaseRequest from '../../../request/index.js';

import GLOBALS from '../../../globals.js';

import {toastMessage} from '../../../common/index.js';

import i18n from '../../../i18n';

export default class DeleteRelease extends Component {
    constructor(props) {
        super(props);

        this.deleteRelease = this.deleteRelease.bind(this);
    }

    async deleteRelease() {
        await ReleaseRequest.deleteRelease(GLOBALS.product.bundleId, this.props.releaseId).then((res) => {
            if (res) {
                GLOBALS.promise.view.emit('refreshReleaseList');
                GLOBALS.promise.view.emit('onGroupProcess', { show: false });
                toastMessage('success', i18n.get('release:success:delete'));
            }
        })
        .catch(err => {
            if (err.status === 403) {
                toastMessage('error', i18n.get('cannot:delete:stable:channel'));
            }
            else {
                toastMessage('error', i18n.get('release:deleting:error'));
            }
        });
    }

    render() {
        return (
            <Popup
                show={true}
                header={`${this.props.releaseVersion} ${i18n.get('you:are:deleting:version')}`}
                headerButtons={[{
                    type: 'transparent',
                    title: i18n.get('close'),
                    color: '#ccc',
                    icon: {
                        component: <FaWindowClose />,
                        size: 25,
                    },
                    onClick: this.props.onClose,
                }]}
                renderContent={() => (
                    <div style={{color:'#2b2b2b'}}>
                        <span>{i18n.get('are:you:sure:want:delete')}</span>
                    </div>
                )}
                footerButtons={[
                    {
                        color: '#fff',
                        backgroundColor: '#474747',
                        text: i18n.get('delete'),
                        onClick: this.deleteRelease,
                        className: 'footer-button',
                    }
                ]}
            />
        );
    }
}

DeleteRelease.defaultProps = {
    releaseId: '',
    releaseVersion: '',
};

DeleteRelease.propTypes = {
    releaseId: PropTypes.number,
    releaseVersion: PropTypes.string,
    onClose: PropTypes.func,
};
